<template>
  <!-- Remark: class outlined-[theme] does not  apply border, so use inline style-->
  <v-list-item class="result-item background" :class="{ 'lighten-1': darkMode }" :style="`border:1px solid #${darkMode ? '404040' : 'e0e0e0'} !important`">
    <v-list-item-content class="pb-2">
      <div class="d-flex" @click="onItemClicked(source, 1, null)">
        <div class="badge d-flex align-center justify-center primary white--text mr-1">
          {{ index + 1 }}
        </div>
        <!-- Hit title-->
        <div
          :style="`width:${xs ? 'calc(100vw - 120px' : 'calc(100% - 120px)'} !important`"
          v-html="source.highlight && source.highlight.title ? source.highlight.title : source.title"
          :class="`title-${themeName}`"
        ></div>

        <!-- score -->
        <!-- <div>maxScore {{ maxScore }} score: {{ source.score }}</div> -->
        <score
          class="ml-3"
          :color="'primary'"
          :barBgColor="darkMode ? 'background lighten-4' : 'background darken-2'"
          :maxScore="maxScore"
          :score="source.score"
        ></score>
      </div>
      <!-- content -->
      <div class="d-flex flex-row align-start">
        <div :class="`module-title-${themeName}`">
          {{ $t('module') }} <b>{{ $t(source.moduleTitle) }}</b>
          <span v-html="source.location ? ', ' + source.location.substring(0, source.location.length - 1) : ''"></span>
          <!-- <span v-if="source.titleSearch"
                style="color:gray"> (Titelsuch-Resultat)</span><span> Score {{source.score}}</span> -->
        </div>
      </div>
      <div v-if="content" :class="`mb-2 d-flex flex-row hit-${themeName}`">
        <!-- Page on sm and up: left side -->

        <div :class="`hit-${themeName}`">
          <div v-html="content"></div>
        </div>
      </div>
      <div
        v-else-if="!this.titleOnly"
        v-for="pageHighlight in pages"
        :key="pageHighlight.page"
        @click="onItemClicked(source, pageHighlight.page, pageHighlight)"
        :class="`mb-2 d-flex flex-row hit-${themeName}`"
      >
        <!-- Page on sm and up: left side -->
        <div v-if="!xs && pageHighlight.page" style="width: 80px">{{ $t('page') }} {{ pageHighlight.page }}</div>

        <div :class="`hit-${themeName}`">
          <!-- Page on xs: above highlight -->
          <div v-if="xs" class="d-flex flex-row full-width mb-0 page-xs">
            <div style="width: 80px" :class="`pb-0 module-title-${themeName}`">{{ $t('page') }} {{ pageHighlight.page }}</div>
          </div>

          <div v-for="(hl, index) in pageHighlight.highlights" :key="index" v-html="hl"></div>
        </div>
      </div>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import common from '@/mixins/common';
import Score from './Score.vue';
import { mapState } from 'vuex';
export default {
  components: { Score },
  mixins: [common],
  name: 'SearchItem',
  props: {
    index: {
      // index of current item
      type: Number,
    },
    source: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  computed: {
    ...mapState({
      maxScore: (state) => state.search.maxScore,
      titleOnly: (state) => state.search.titleOnly,
    }),
    pages() {
      return this.source.highlight ? this.source.highlight.pages : [];
    },
    content() {
      return !this.titleOnly && this.source.highlight && this.source.highlight.content ? this.source.highlight.content : '';
    },
  },

  methods: {
    onItemClicked(item, page, highlight) {
      console.debug('onItemClicked page=', page);

      this.$store.commit('search/resetSearchResults', { root: true });
      if (item.path === this.$route.path && page === this.$route.query.page) {
        //console.debug('item clicked but the same document is already open', item, page);
      } else {
        if (item.path.indexOf('?') > -1) {
          //Messaging module needs to set path like 'messaging?id=3&uuid=abc123&isGroup=0' to scroll to a message
          const query = Object.fromEntries(new URLSearchParams(item.path.split('?')[1]));
          this.$router.push({ path: item.path.split('?')[0], query });
        } else {
          const searchTerm = highlight ? this.$store.state.search.search.replace('*', '') : null;
          this.$router.push({ path: item.path, query: { page, search: searchTerm } });
        }
      }

      this.$store.commit('search/setIsSearchVisible', false);
    },
  },
};
</script>

<style>
/* Leave as !!! unscoped !!! - the title-light highlight is ignored when using a scoped style here */
.badge {
  transform: translateY(-5px);
  border-radius: 18px;
  font-weight: 600;
  font-size: 10px;
  width: 24px;
  height: 24px;
  padding: 2px;
}
.result-item {
  border-radius: 6px;
  margin-bottom: 6px;
}
.title-light,
.title-dark {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 700;
  padding-bottom: 5px;
}
.hit-light em,
.title-light > em {
  background: yellow !important;
}
.title-dark > em,
.hit-dark em {
  background: #5c5b04 !important;
}
.module-title-dark,
.hit-dark {
  color: #b0b0b0;
}
.module-title-light,
.hit-light {
  color: #808080;
}
.module-title-dark,
.module-title-light {
  font-size: 0.8rem !important;
  line-height: 1;
  padding-bottom: 5px;
}

.hit-light,
.hit-dark {
  line-height: 1.2;
  font-size: 0.8rem !important;
}
@media all and (max-width: 600px) {
  .module-title-dark,
  .module-title-light {
    font-size: 0.75rem !important;
  }
  .hit-light,
  .hit-dark {
    font-size: 0.75rem !important;
  }
  .page-xs {
    padding-top: 3px !important;
    padding-bottom: 2px;
  }
}
</style>
